import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { MeasurementSystem, VelavuDevice } from "velavu-js-api";
import IconHumidity from "../../dynamicicons/icon-humidity";
import IconTemperature from "../../dynamicicons/icon-temperature";
import CategorizationTag from "../../elements/categorization-tag";
import IconLabelAttribute, {
	BatteryIconLabelAttribute,
} from "../../elements/icon-label-attribute";
import SelectableCard from "../../elements/selectable-card";
import StatusIndicator from "../../elements/status-indicator";
import { makeStyleable } from "../../helper/icon-helper";
import { mapDeviceModel } from "../../helper/language-helper";
import { getDeviceStatus } from "../../helper/status-helper";
import { classArr } from "../../helper/style-helper";
import { formatTemperature } from "../../helper/unit-helper";
import * as styles from "./analytics-sidebar-device-card.module.scss";

export interface AnalyticsSidebarDeviceCardProps {
	style?: CSSProperties;
	className?: string;

	device: VelavuDevice;
	measurementSystem: MeasurementSystem;

	isSelected: boolean;
	isNonApplicable: boolean;

	onClick?: VoidFunction;
}

export default function AnalyticsSidebarDeviceCard(
	props: AnalyticsSidebarDeviceCardProps,
) {
	const { t } = useTranslation();

	const temperature = props.device.environment?.temperature_c;
	const humidity = props.device.environment?.humidity;

	return (
		<SelectableCard
			style={props.style}
			className={classArr(
				styles.container,
				props.isSelected && styles.containerSelected,
				props.isNonApplicable && styles.containerNonApplicable,
				props.className,
			)}
			onClick={props.onClick}
		>
			<div className={styles.row}>
				<StatusIndicator status={getDeviceStatus(props.device)} />
				<span className={styles.title}>
					{props.device.asset?.name ?? props.device.id}
				</span>

				{props.device.asset !== undefined && (
					<CategorizationTag
						className={styles.class}
						categorization={props.device.asset}
					/>
				)}
			</div>
			<div className={styles.row}>
				<span className={styles.subtitle}>
					{mapDeviceModel(props.device.model, t)}
				</span>

				<div style={{ flexGrow: 1 }} />

				{temperature !== undefined && (
					<IconLabelAttribute
						className={styles.attribute}
						icon={makeStyleable(IconTemperature)}
						label={`${Math.round(
							formatTemperature(
								temperature,
								props.measurementSystem,
							),
						)}º`}
					/>
				)}

				{humidity !== undefined && (
					<IconLabelAttribute
						className={styles.attribute}
						icon={makeStyleable(IconHumidity)}
						label={`${Math.round(humidity)}%`}
					/>
				)}

				<BatteryIconLabelAttribute
					className={styles.attribute}
					resource={props.device.state?.power}
				/>
			</div>
		</SelectableCard>
	);
}
